var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnavailableService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "394px",
    height: "197px",
    viewBox: "0 0 394 197",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.6069 0.5862 7.0209 0.5862 7.0209 7 0.6069 7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-1024-infinito-Copy-2",
    transform: "translate(-529.000000, -385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(530.000400, 385.572800)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 172.2228,
    x2: 370.875,
    y2: 172.2228,
    id: "Stroke-1",
    stroke: "#DAEBF7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 379.6807,
    y1: 172.2228,
    x2: 392.0267,
    y2: 172.2228,
    id: "Stroke-3",
    stroke: "#DAEBF7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9971,171.175 C17.9971,76.637 94.6351,8.52651283e-14 189.1731,8.52651283e-14 C283.7101,8.52651283e-14 360.3481,76.637 360.3481,171.175",
    id: "Fill-5",
    fill: "#F8FAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.8266,25.8412 C248.8266,29.3832 245.9556,32.2552 242.4136,32.2552 C238.8716,32.2552 235.9996,29.3832 235.9996,25.8412 C235.9996,22.2992 238.8716,19.4272 242.4136,19.4272 C245.9556,19.4272 248.8266,22.2992 248.8266,25.8412 Z",
    id: "Stroke-7",
    stroke: "#E7F0F8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9996,141.4272 C36.9996,143.636118 35.209002,145.4272 32.9999118,145.4272 C30.7908216,145.4272 28.9996,143.636118 28.9996,141.4272 C28.9996,139.218282 30.7908216,137.4272 32.9999118,137.4272 C35.209002,137.4272 36.9996,139.218282 36.9996,141.4272",
    id: "Fill-9",
    fill: "#E5EFF7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(320.999600, 189.365200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0209,3.7932 C7.0209,5.5642 5.5839,7.0002 3.8139,7.0002 C2.0419,7.0002 0.6069,5.5642 0.6069,3.7932 C0.6069,2.0222 2.0419,0.5862 3.8139,0.5862 C5.5839,0.5862 7.0209,2.0222 7.0209,3.7932",
    id: "Fill-11",
    fill: "#C8E0F0",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 259.9776,
    y1: 51.3923,
    x2: 259.9776,
    y2: 59.5513,
    id: "Stroke-14",
    stroke: "#DEECF5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.8242,
    y1: 74.5871,
    x2: 275.6662,
    y2: 74.5871,
    id: "Stroke-16",
    stroke: "#DEECF5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.7383,
    y1: 58.4787,
    x2: 270.7253,
    y2: 64.4907,
    id: "Stroke-18",
    stroke: "#DEECF5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(177.999600, 17.427200)",
    stroke: "#E0ECF6",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.0859,
    y1: -1.12798659e-13,
    x2: 7.0859,
    y2: 14.173,
    id: "Stroke-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -9.76996262e-14,
    y1: 7.0865,
    x2: 14.173,
    y2: 7.0865,
    id: "Stroke-22"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 266.4356,
    y1: 147.7453,
    x2: 266.4356,
    y2: 82.2383,
    id: "Stroke-40",
    stroke: "#D5ECF9",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.7295,148.7687 L271.3095,148.7687 C272.9085,148.7687 274.2155,150.0987 274.2155,151.7227 L274.2155,159.7717 C274.2155,165.8227 269.3445,170.7737 263.3915,170.7737 L114.9545,170.7737 C109.0005,170.7737 104.1285,165.8227 104.1285,159.7717 L104.1285,151.7227 C104.1285,150.0987 105.4375,148.7687 107.0355,148.7687 L239.5205,148.7687",
    id: "Stroke-48",
    stroke: "#0095E3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.377,162.196 L178.412,162.196 C177.491,162.196 176.738,161.443 176.738,160.521 L176.738,157.157 C176.738,156.236 177.491,155.483 178.412,155.483 L199.377,155.483 C200.298,155.483 201.051,156.236 201.051,157.157 L201.051,160.521 C201.051,161.443 200.298,162.196 199.377,162.196",
    id: "Fill-50",
    fill: "#00D787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.0127,142.4118 L113.0127,79.4968 C113.0127,74.6008 116.9817,70.6318 121.8767,70.6318 L255.1067,70.6318 C260.0017,70.6318 263.9707,74.6008 263.9707,79.4968 L263.9707,148.7688",
    id: "Stroke-64",
    stroke: "#0095E3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(165.999600, 81.927200)",
    fill: "#C8E0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0007903,44.9994468 C12.5159387,44.9994468 10.5005532,42.985642 10.5005532,40.4992097 C10.5005532,38.014358 12.5159387,35.9989725 15.0007903,35.9989725 C17.485642,35.9989725 19.5010275,38.014358 19.5010275,40.4992097 C19.5010275,42.985642 17.485642,44.9994468 15.0007903,44.9994468 M28.8144792,38.0949734 L27.5404394,37.9195163 C27.004584,37.8452237 26.5841193,37.4532114 26.4244692,36.9363244 C26.207914,36.2423995 25.9281311,35.5753464 25.5946046,34.941488 C25.3432741,34.4641182 25.3638232,33.8919068 25.6894462,33.4603773 L26.3754676,32.5530586 C26.8844512,31.8828442 26.8291269,31.1146267 26.3438537,30.6293535 L24.8706465,29.1561463 C24.3853733,28.6708731 23.6155751,28.6171295 23.0686548,29.0312714 L22.0427841,29.8089731 C21.6112545,30.1361768 21.0343011,30.1551452 20.5553507,29.9038147 C19.9214922,29.5702882 19.2560198,29.292086 18.5636756,29.0771115 C18.0483693,28.9158807 17.6547763,28.4969967 17.5804837,27.9595606 L17.4050266,26.6871015 C17.3101849,26.0058222 16.7284894,25.5 16.042468,25.5 L13.9591127,25.5 C13.2715106,25.5 12.6913958,26.0058222 12.5965541,26.6871015 L12.421097,27.9595606 C12.3468044,28.4969967 11.9532114,28.9158807 11.4379051,29.0771115 C10.7439802,29.292086 10.0769271,29.5718689 9.44306865,29.9053954 C8.96569893,30.1567259 8.39190684,30.1377575 7.96195795,29.8121345 L7.05463934,29.1245324 C6.3828442,28.6155488 5.61620739,28.6708731 5.13093419,29.1561463 L3.65772696,30.6293535 C3.17245376,31.1146267 3.11871015,31.8844249 3.5328521,32.4313452 L4.31055377,33.4572159 C4.63617683,33.8903261 4.65672585,34.4656989 4.40539544,34.9446493 C4.07186891,35.5785078 3.79208599,36.2455609 3.57553085,36.9394857 C3.41588071,37.4547921 2.99857737,37.8452237 2.46430265,37.9195163 L1.33726751,38.0744244 C0.50424153,38.1898151 0,38.7715106 0,39.457532 L0,41.5408873 C0,42.2284894 0.507402919,42.8086042 1.18710153,42.9034459 L2.46114126,43.078903 C2.99699668,43.1547763 3.41588071,43.5467886 3.57711154,44.0620949 C3.79366668,44.7576005 4.0734496,45.4246536 4.40697613,46.0569313 C4.65830655,46.5343011 4.63775752,47.1080932 4.31213446,47.538042 L3.62611307,48.4469414 C3.11712946,49.1171558 3.17245376,49.8837926 3.65772696,50.3690658 L5.13093419,51.8438537 C5.61620739,52.3291269 6.38600559,52.3812898 6.93292587,51.9671479 L7.95879656,51.1910269 C8.39032615,50.8622425 8.96727962,50.8432741 9.44623004,51.0961853 C10.0800885,51.4281311 10.7455609,51.7063333 11.4379051,51.9228885 C11.9532114,52.0841193 12.3468044,52.5030033 12.421097,53.0388587 L12.5965541,54.3128985 C12.6913958,54.9925971 13.2715106,55.5 13.9591127,55.5 L16.042468,55.5 C16.7284894,55.5 17.3101849,54.9925971 17.4050266,54.3128985 L17.5804837,53.0388587 C17.6547763,52.5030033 18.0483693,52.0841193 18.5636756,51.9228885 C19.2576005,51.7063333 19.9246536,51.4281311 20.558512,51.0930239 C21.0358818,50.8432741 21.6096739,50.8622425 22.0396227,51.1878655 L22.9469414,51.8754676 C23.6187365,52.3828705 24.3853733,52.3291269 24.8706465,51.8438537 L26.3438537,50.3690658 C26.8291269,49.8837926 26.8828705,49.1155751 26.4687286,48.5670741 L25.6910269,47.5412034 C25.3638232,47.1080932 25.3448548,46.5343011 25.5961853,46.05377 C25.9297118,45.4199115 26.207914,44.7528584 26.4260498,44.0589336 C26.5857,43.5452079 27.0030033,43.1547763 27.537278,43.0804837 L28.6643132,42.9239949 C29.4973392,42.8086042 30,42.2284894 30,41.5408873 L30,39.457532 C30,38.7715106 29.4941778,38.1898151 28.8144792,38.0949734",
    id: "Fill-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9992097,19.9994468 C30.5159387,19.9994468 28.4989725,17.985642 28.4989725,15.4992097 C28.4989725,13.014358 30.5159387,10.9989725 32.9992097,10.9989725 C35.485642,10.9989725 37.5010275,13.014358 37.5010275,15.4992097 C37.5010275,17.985642 35.485642,19.9994468 32.9992097,19.9994468 M46.8128985,13.0949734 L45.5404394,12.9195163 C45.004584,12.8452237 44.5841193,12.4532114 44.4244692,11.9363244 C44.2063333,11.2423995 43.9281311,10.5753464 43.5946046,9.94148796 C43.3432741,9.46411824 43.3638232,8.89190684 43.6894462,8.46037726 L44.3754676,7.55305864 C44.8844512,6.8828442 44.8275462,6.11462669 44.3438537,5.6293535 L42.8706465,4.15614627 C42.3837926,3.67087307 41.6155751,3.61712946 41.0670741,4.03127141 L40.0412034,4.80897308 C39.6096739,5.13617683 39.0343011,5.15514516 38.5553507,4.90381474 C37.9214922,4.57028821 37.2560198,4.29208599 36.5636756,4.07711154 C36.0467886,3.91588071 35.6547763,3.49699668 35.5804837,2.95956057 L35.4034459,1.68710153 C35.3101849,1.00582222 34.7284894,0.5 34.0408873,0.5 L31.9591127,0.5 C31.2715106,0.5 30.6898151,1.00582222 30.5949734,1.68710153 L30.4195163,2.95956057 C30.3452237,3.49699668 29.9532114,3.91588071 29.4363244,4.07711154 C28.7423995,4.29208599 28.0769271,4.57186891 27.441488,4.90539544 C26.9656989,5.15672585 26.3919068,5.13775752 25.961958,4.81213446 L25.0546393,4.12453238 C24.3828442,3.61554876 23.6146267,3.67087307 23.1293535,4.15614627 L21.6561463,5.6293535 C21.1724538,6.11462669 21.1171295,6.88442489 21.5328521,7.43134517 L22.3089731,8.45721587 C22.6361768,8.89032615 22.6567259,9.46569893 22.4038147,9.94464935 C22.0702882,10.5785078 21.792086,11.2455609 21.5755308,11.9394857 C21.4158807,12.4547921 20.9969967,12.8452237 20.4643027,12.9195163 L19.3356868,13.0744244 C18.5042415,13.1898151 18,13.7715106 18,14.457532 L18,16.5408873 C18,17.2284894 18.5058222,17.8086042 19.1871015,17.9034459 L20.4595606,18.0804837 C20.995416,18.1547763 21.4158807,18.5467886 21.5755308,19.0620949 C21.7936667,19.7576005 22.0718689,20.4246536 22.4053954,21.0569313 C22.6567259,21.5343011 22.6377575,22.1080932 22.3105538,22.538042 L21.6245324,23.4469414 C21.1155488,24.1171558 21.1724538,24.8837926 21.6561463,25.3690658 L23.1293535,26.8438537 C23.6146267,27.3291269 24.3844249,27.3812898 24.9313452,26.9671479 L25.9587966,26.1910269 C26.3903261,25.8622425 26.9672796,25.8432741 27.4446493,26.0961853 C28.0785078,26.4281311 28.7439802,26.7063333 29.4363244,26.9228885 C29.9532114,27.0841193 30.3452237,27.5030033 30.4195163,28.0388587 L30.5949734,29.3128985 C30.6898151,29.9925971 31.2715106,30.5 31.9591127,30.5 L34.0408873,30.5 C34.7284894,30.5 35.3101849,29.9925971 35.4034459,29.3128985 L35.5804837,28.0388587 C35.6547763,27.5030033 36.0467886,27.0841193 36.5636756,26.9228885 C37.2576005,26.7063333 37.9246536,26.4281311 38.558512,26.0930239 C39.0343011,25.8432741 39.6080932,25.8622425 40.038042,26.1878655 L40.9453607,26.8754676 C41.6171558,27.3828705 42.3837926,27.3291269 42.8706465,26.8438537 L44.3438537,25.3690658 C44.8275462,24.8837926 44.8828705,24.1155751 44.4671479,23.5670741 L43.6910269,22.5412034 C43.3638232,22.1080932 43.3448548,21.5343011 43.5961853,21.05377 C43.9297118,20.4199115 44.207914,19.7528584 44.4244692,19.0589336 C44.5841193,18.5452079 45.0030033,18.1547763 45.5356973,18.0804837 L46.6643132,17.9239949 C47.4957585,17.8086042 48,17.2284894 48,16.5408873 L48,14.457532 C48,13.7715106 47.4941778,13.1898151 46.8128985,13.0949734",
    id: "Fill-37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(79.999600, 12.427200)",
    stroke: "#C8E0F0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16.3783,
    y1: 54.7984,
    x2: 9.4573,
    y2: 63.8944,
    id: "Stroke-39"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.4515,
    y1: 49.4459,
    x2: 20.3025,
    y2: 49.6429,
    id: "Stroke-41"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.9418,
    y1: 62.4385,
    x2: 12.8628,
    y2: 66.4845,
    id: "Stroke-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8822,27.4962 L36.0982,13.9632 C35.6942,13.6562 35.6152,13.0792 35.9232,12.6752 L42.0432,4.6322 C42.3502,4.2282 42.9272,4.1502 43.3312,4.4572 L61.1152,17.9902 C61.5202,18.2972 61.5982,18.8742 61.2902,19.2782 L55.1702,27.3212 C54.8632,27.7252 54.2862,27.8032 53.8822,27.4962 Z",
    id: "Stroke-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4154,34.7496 L60.6194,32.6226 C59.6534,31.8876 59.4664,30.5086 60.2014,29.5426 L64.7724,23.5346 C65.5084,22.5686 66.8874,22.3816 67.8524,23.1166 L70.6474,25.2436 L63.4154,34.7496 Z",
    id: "Stroke-47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-49",
    points: "60.7924 28.7662 56.5354 25.5272 59.9254 21.0722 64.1824 24.3112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7406,8.9732 L31.4896,3.4552 C35.7356,-2.1248 38.6756,0.8992 42.6066,3.8912 L38.7406,8.9732 Z",
    id: "Stroke-51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-53",
    points: "32.6908 44.335 25.5188 38.878 41.4048 18.002 48.5758 23.459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4008,75.2603 L2.9898,73.4263 C0.7578,71.7273 0.3258,68.5413 2.0238,66.3093 L21.9888,40.0713 L32.4818,48.0553 L12.5168,74.2943 C10.8188,76.5263 7.6318,76.9583 5.4008,75.2603 Z",
    id: "Stroke-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5599,48.1148 L21.9119,40.0118 C21.2329,39.4958 21.1009,38.5278 21.6179,37.8488 C22.1329,37.1708 23.1019,37.0388 23.7809,37.5548 L34.4289,45.6578 C35.1079,46.1748 35.2389,47.1428 34.7229,47.8218 C34.2059,48.4998 33.2379,48.6308 32.5599,48.1148 Z",
    id: "Stroke-57"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.328368,101.8092 C302.302368,98.6902 299.509368,96.6502 296.425368,96.4272 L298.104368,102.2972 C298.465368,103.6222 297.890368,105.0932 296.639368,105.6592 C295.181368,106.3192 293.507368,105.6102 292.942368,104.1582 L290.752368,98.2942 C288.158368,100.5162 287.166368,104.3092 288.786368,107.6962 C290.054368,110.3462 292.763368,112.0272 295.629368,112.1202 L303.515368,141.1782 C304.156368,143.5412 306.649368,144.8832 308.975368,144.1182 C311.302368,143.3522 312.510368,140.7922 311.623368,138.5102 L300.711368,110.4432 C303.239368,108.4582 304.390368,105.0392 303.328368,101.8092",
    id: "Fill-60",
    fill: "#C8E0F0",
    transform: "translate(299.957324, 120.380358) rotate(-22.000000) translate(-299.957324, -120.380358) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(62.999600, 103.427200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5797015,67.6262 L8.88270155,67.6262 C6.36170155,67.6262 4.30070155,65.6472 4.30070155,63.2272 L0.0257015451,32.6992 C-0.202298455,31.0722 1.11570155,29.6262 2.82570155,29.6262 L29.6367015,29.6262 C31.3467015,29.6262 32.6647015,31.0722 32.4357015,32.6992 L28.1617015,63.2272 C28.1617015,65.6472 26.1007015,67.6262 23.5797015,67.6262",
    id: "Fill-26",
    fill: "#E5EFF7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.3141015,
    y1: 24.425,
    x2: 29.3731015,
    y2: 9.05941988e-14,
    id: "Stroke-68",
    stroke: "#E5EFF7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.9587015,
    y1: 24.425,
    x2: 8.85470155,
    y2: 8.352,
    id: "Stroke-70",
    stroke: "#E5EFF7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailableService);
export default __webpack_public_path__ + "static/media/unavailableService.05c734c778fd5b0952ef621bd2ebb41d.svg";
export { ForwardRef as ReactComponent };